import Icon from '../components/Icon.vue'

Icon.register({
  'hand-rock': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464.8 80c26.3 0.4 47.2 22.5 47.2 48.8v133.5c0 12.8-2.5 25.5-7.5 37.3l-49 116.3c-4.9 11.8-7.5 24.5-7.5 37.3v2.9c0 13.3-10.7 24-24 24h-240c-13.3 0-24-10.7-24-24v-6.7c0-13.7-5.9-26.8-16.1-35.9l-111.7-99.3c-20.5-18.3-32.2-44.4-32.2-71.8v-66.4c0-26.8 21.9-48.4 48.8-48 26.3 0.5 47.2 22.5 47.2 48.8v48.1l8 7.1v-136c0-26.8 21.9-48.4 48.8-48 26.3 0.5 47.2 22.5 47.2 48.8v31.2h8v-48c0-26.8 21.9-48.4 48.8-48 26.3 0.5 47.2 22.5 47.2 48.8v47.2h8v-32c0-26.8 21.9-48.4 48.8-48 26.3 0.5 47.2 22.5 47.2 48.8v31.2h8c0-26.8 21.9-48.4 48.8-48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-rock.js
// module id = 1436
// module chunks = 0